import {createSlice} from "@reduxjs/toolkit";
import {setUIPipelineFlowSearchFilter} from "./actions";
import {PipelineFlowSearchCriteria} from "@ots-frontend/ots-data";

type PipelineFlowUIState = {
  searchFilter?: PipelineFlowSearchCriteria
}

const INITIAL_STATE: Readonly<PipelineFlowUIState> = {};

const pipelineFlowUISlice = createSlice({
  name: "ots-ui/pipeline-flow",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setUIPipelineFlowSearchFilter,
      (state, {payload}) => {
        state.searchFilter = payload
      }
    );
  }
});

export const pipelineFlowUIReducer = pipelineFlowUISlice.reducer;
